import { styled, TableRow as MuiTableRow } from '@material-ui/core';
import { palette } from '../../settings/themes/colors';

export const TableRow = styled(MuiTableRow)({
  '& *[class^="MuiTableCell-root"]': {
    fontWeight: 500,
    color: palette.dimGray
  }
});
